import { useState, useEffect } from 'react';
import InterestModal from './InterestModal';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    // Check scroll position on mount
    const checkScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };
    
    // Check immediately
    checkScroll();
    
    // Then add listener
    window.addEventListener('scroll', checkScroll);
    return () => window.removeEventListener('scroll', checkScroll);
  }, []);

  const sections = [
    { id: 'overview', label: 'نظرة عامة' },
    { id: 'about', label: 'عن المشروع' },
    { id: 'spaces', label: 'المساحات' },
    { id: 'impact', label: 'الأثر' },
    { id: 'kpis', label: 'المؤشرات' },
    { id: 'financial', label: 'الجدوى المالية' },
    { id: 'partnership', label: 'الشراكة' },
    { id: 'partners', label: 'شركاؤنا' },
  ];

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80; // navbar height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white shadow-lg py-4'
          : 'bg-transparent py-6'
      }`}
    >
      <div className="container mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <div className="w-10 h-10 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-full flex items-center justify-center">
              <i className="ri-lightbulb-flash-line text-white text-xl"></i>
            </div>
            <div className="flex flex-col leading-tight">
              <span className={`font-bold text-xl transition-colors duration-300 uppercase tracking-wide ${
                isScrolled ? 'text-gray-800' : 'text-white drop-shadow-lg'
              }`}>
                YOUTH SPACE
              </span>
              <span className={`text-xs font-medium transition-colors duration-300 ${
                isScrolled ? 'text-gray-500' : 'text-white/80'
              }`}>
                مساحات المستقبل
              </span>
            </div>
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center gap-8">
            {sections.map((section) => (
              <button
                key={section.id}
                onClick={() => scrollToSection(section.id)}
                className={`font-medium transition-colors duration-300 ${
                  isScrolled 
                    ? 'text-gray-700 hover:text-[#FF6B6B]' 
                    : 'text-white/90 hover:text-white drop-shadow-lg'
                }`}
              >
                {section.label}
              </button>
            ))}
            <button
              onClick={() => setIsModalOpen(true)}
              className={`px-6 py-2 rounded-full font-semibold hover:shadow-lg transition-all duration-300 cursor-pointer ${
                isScrolled
                  ? 'bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] text-white'
                  : 'bg-white/10 text-white border-2 border-white/70 hover:bg-white/20 hover:border-white'
              }`}
            >
              كن شريكاً
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className={`lg:hidden text-2xl transition-colors duration-300 ${
              isScrolled ? 'text-gray-800' : 'text-white drop-shadow-lg'
            }`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className={`lg:hidden mt-4 rounded-2xl transition-all duration-300 overflow-hidden ${
            isScrolled
              ? 'bg-white border border-gray-200 shadow-lg'
              : 'bg-white/10 backdrop-blur-md border border-white/20'
          }`}>
            <div className="flex flex-col divide-y divide-white/10">
              {sections.map((section) => (
                <button
                  key={section.id}
                  onClick={() => scrollToSection(section.id)}
                  className={`text-right font-medium transition-colors duration-200 px-5 py-3.5 ${
                    isScrolled
                      ? 'text-gray-700 hover:text-[#FF6B6B] hover:bg-gray-50'
                      : 'text-white/90 hover:text-white hover:bg-white/10'
                  }`}
                >
                  {section.label}
                </button>
              ))}
              <div className="px-5 py-4">
                <button
                  onClick={() => setIsModalOpen(true)}
                  className="w-full bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] text-white px-6 py-3 rounded-full font-semibold hover:shadow-lg transition-all duration-300 text-center cursor-pointer"
                >
                  كن شريكاً
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Interest Modal */}
      <InterestModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        projectName="مساحة شباب - YOUTH SPACE"
      />
    </nav>
  );
}
